import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {CreateTemplateDialogComponent} from '../../create-template-dialog/create-template-dialog.component';
import { formatCost } from '@shared/utils/invoice.util';

@Component({
  selector: 'app-delivery-cost-check-popup',
  templateUrl: './delivery-cost-check-popup.component.html',
  styleUrls: ['./delivery-cost-check-popup.component.scss'],
})

export class DeliveryCostCheckPopupComponent {
  protected readonly formatCost = formatCost;

  @Output()
  onAdd = new EventEmitter<void>();
  @Output()
  onClear = new EventEmitter<void>();
  @Input()
  cost;
  @Input()
  announcedCost;
  message;
  description;
  confirmCloseTooltip;

  constructor(
    private dialogRef: MatDialogRef<CreateTemplateDialogComponent>,
  ) {
  }

  private _type;

  get type() {
    return this._type;
  }

  @Input() set type(value) {
    this._type = value;
    if (value === 'BackwardDeliveryData' || value === 'AdditionalServices') {
      this.message =
        `Сума післяплати не може перевищувати загальну оголошену цінність.</br>
         Оголошена цінність за всіма місцями буде автоматично перерахована, зі збереженням пропорцій між місцями.`;
      this.description = 'Оголошена цінність становитиме';
      this.confirmCloseTooltip = 'Сума післяплати буде дорівнювати оголошеній цінності.';
    } else {
      this.message = `Сума контролю оплати не може перевищувати загальну оголошену цінність.</br>
         Оголошена цінність за всіма місцями буде автоматично перерахована, зі збереженням пропорцій між місцями.`;
      this.description = 'Оголошена цінність становитиме';
      this.confirmCloseTooltip = 'Сума контролю оплати буде дорівнювати оголошеній цінності.';
    }
  };

  close(): void {
    this.onClear.next();
    this.dialogRef.close();
  }

  onButtonClick() {
    this.onAdd.next();
    this.dialogRef.close();
  }
}
